import GoogleMap from './googleMap'
export default GoogleMap